module.exports = __webpack_public_path__ + "assets/2.c1824525.png";